import { View, StyleSheet } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { SafeAreaView } from 'react-native-safe-area-context'
import ProviderTimeline, { TimelineMessage } from '../../src/components/ProviderTimeline'
import { colors } from '../../src/theme'
export { ScreenErrorBoundary as ErrorBoundary } from '../../src/components/ScreenErrorBoundary'

export default function ThreadScreen() {
  const { id, providerName, subject, messages: paramMessages } = useLocalSearchParams<{
    id: string
    providerName?: string
    subject?: string
    messages?: string
  }>()
  const router = useRouter()

  const provider = providerName || 'selskabet'

  // Parse preloaded messages if passed from inbox
  let preloaded: TimelineMessage[] | undefined
  if (paramMessages) {
    try {
      preloaded = JSON.parse(paramMessages) as TimelineMessage[]
    } catch {
      // Will fall back to API fetch via ProviderTimeline
    }
  }

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <ProviderTimeline
        providerId={id}
        providerName={provider}
        onClose={() => router.back()}
        preloadedMessages={preloaded}
      />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: colors.surface },
})
